<template>
  <Posts :object="object" :params="params" :key="version" />
</template>

<script>
import {defineComponent, onMounted, ref} from "vue"
import Posts from "@/modules/post/pages/posts/components/posts/Posts"
import Notes from "@/modules/post/pages/posts/services/Notes"

export default defineComponent({
  name: "Notes",
  components: {
    Posts
  },
  setup() {
    let version = ref(0)
    let object = new Notes()

    let params = {
      title: "Все заметки",
      h1: "Заметки",
      page: "notes",
      type_ids: [5],
      channel_id: getChannelId(),
    }

    function getChannelId() {
      return 1
    }

    onMounted(() => {
      version.value++
    })

    return {
      object,
      params,
      version,
    }
  }
})
</script>

<style scoped>

</style>
